const dataManager = "delivery";
const keyPrefix = dataManager + "_"
export const saveDataToLocalStorage = (key, value) => {
    if ((!key || !value) && key !== false &&  value !== false) {
        return
    }
    localStorage.setItem(AddFix(key), value)
}

export const getDataInLocalStorage = (key) => {
    if (!key) {
        return ''
    }
    const value = localStorage.getItem(AddFix(key));
    if(value === false){
        return false
    }
    if (!value) {
        return ''
    }
    return value
}
export const removeDataInLocalStorage = (key) => {
    localStorage.removeItem(AddFix(key))
}
export const AddFix = (value) => {
    value = keyPrefix + value
    return value

}
